import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { FiveBenefitsOfProfessionalPrinters } from './components/FiveBenefitsPrint';
import { Header } from './components/Header';

function Blog() {
  return (
    <div className="App">
      <Header />
      <FiveBenefitsOfProfessionalPrinters />
    </div>
  );
}

export default Blog;
